import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import { Link } from 'react-router-dom';
import emeralds from '../assets/emeralds.jpg';
import lilacVariation from '../assets/lilac_variation.jpg';
import kitriAct3 from '../assets/kitri_act3.jpg';
import giselleAct1 from '../assets/giselle_act1.jpg';
import littleSwans from '../assets/4_little_swans.jpg';
import awakeningOfFlora from '../assets/awakening_of_flora.jpg';
import laBayadere from '../assets/la_bayadere.jpg';
import talisman from '../assets/talisman.jpg';
import pharaohsDaughter from '../assets/pharaohs_daughter.jpg';
import medoraAct3 from '../assets/medora_act_3.jpg';
import esmeralda from '../assets/esmeralda.jpg';

const ExploreVariationsClasses = ({ isOpen, onClose }) => {
  const [activeTab, setActiveTab] = useState('upcoming');
  const [newsletterEmail, setNewsletterEmail] = useState('');
  const [newsletterSubmitting, setNewsletterSubmitting] = useState(false);
  const [newsletterStatus, setNewsletterStatus] = useState('');
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  React.useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Lock background scroll while modal is open
  React.useEffect(() => {
    if (isOpen) {
      const prev = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      return () => { document.body.style.overflow = prev; };
    }
  }, [isOpen]);

  if (!isOpen) return null;

  const handleNewsletterSubmit = async (e) => {
    e.preventDefault();
    setNewsletterSubmitting(true);
    try {
      const response = await fetch('/api/subscribe', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: newsletterEmail }),
      });
      if (response.ok) {
        setNewsletterStatus('submitted');
        setNewsletterEmail('');
      } else {
        setNewsletterStatus('error');
      }
    } catch {
      setNewsletterStatus('error');
    }
    setNewsletterSubmitting(false);
  };

  const pastClasses = [
    {
      month: 'July 2026',
      title: 'Esmeralda',
      styleDescription: "The Esmeralda variation is a sparkling gem of the classical repertoire — vibrant, playful, and technically precise. Featuring quick tambourine-led rhythms, sharp footwork, and a bright, infectious character, this variation demands both technical clarity and spirited performance quality.",
      description: "A high-energy 4-week study of the Esmeralda variation. With its lively musicality and bright characterization, this was the perfect pre-competition class to sharpen technique and stage confidence.",
      dates: 'Jul 4th - Jul 25th, every Saturday',
      time: 'Noon - 2:00 PM',
      level: 'Adults Only',
      image: esmeralda,
      completed: true
    },
    {
      month: 'June 2026',
      title: 'Medora Act III',
      styleDescription: "Medora's Act III variation from Le Corsaire is one of classical ballet's most beloved solos. This Petipa gem showcases brilliant turns, crisp footwork, and a triumphant, joyful energy that is both technically rigorous and dramatically captivating.",
      description: "Explored the brilliance of Le Corsaire with this 4-week deep dive into Medora's Act III variation. Students worked on clean technique, musical interpretation, and the confident, joyful character that makes this variation a competition favourite.",
      dates: 'Jun 6th - Jun 27th, every Saturday',
      time: 'Noon - 2:00 PM',
      level: 'Adults Only',
      image: medoraAct3,
      completed: true
    },
    {
      month: 'May 2026',
      title: "Pharaoh's Daughter",
      styleDescription: "La Fille du Pharaon is a grand Petipa classic bursting with regal elegance and dramatic expression. This variation blends sweeping arabesques, powerful balances, and intricate footwork that reflect the timeless grandeur of the East.",
      description: "Dove into one of Petipa's most spectacular creations with this 4-week exploration of Pharaoh's Daughter. Dancers developed their classical technique, expansive port de bras, and commanding stage presence in this regal and dramatic variation.",
      dates: 'May 9th - May 30th, every Saturday',
      time: 'Noon - 2:00 PM',
      level: 'Adults Only',
      image: pharaohsDaughter,
      completed: true
    },
    {
      month: 'April 2026',
      title: 'La Bayadère',
      styleDescription: 'La Bayadère is one of classical ballet\'s most iconic works, featuring the legendary Kingdom of the Shades scene. This Petipa masterpiece showcases pure classical technique through sustained arabesque walks, ethereal balances, and sweeping port de bras.',
      description: 'Explored the realm of classical ballet\'s most haunting and beautiful scenes. This 4-week series guided dancers through the elegance and purity of La Bayadère — flowing lines, controlled balances, and expressive artistry that define this timeless Petipa masterpiece.',
      dates: 'Apr 4th - Apr 25th, every Saturday',
      time: 'Noon - 2:00 PM',
      level: 'Beginner Friendly',
      image: laBayadere,
      completed: true
    },
    {
      month: 'March 2026',
      title: 'Awakening of Flora',
      styleDescription: 'The Awakening of Flora is a charming Petipa gem brimming with lightness and joy. This variation showcases delicate allegro footwork, graceful port de bras, and a fresh spring-like quality as Flora herself brings nature back to life. The choreography balances technical precision with a warm, radiant expressiveness.',
      description: 'Brought the spirit of spring to life with Petipa\'s charming Awakening of Flora. This delightful 4-week series explored the light footwork, graceful arms, and radiant character of Flora — a wonderful journey into the joyful side of classical ballet.',
      dates: 'Mar 6th - Mar 27th, every Saturday',
      time: 'Noon - 2:00 PM',
      level: 'Beginner Friendly',
      image: awakeningOfFlora,
      completed: true
    },
    {
      month: 'February 2026',
      title: 'Talisman',
      styleDescription: 'The Talisman variation from Petipa and Drigo\'s beloved ballet sparkles with the spirit of the air. Featuring quick, precise footwork, playful turns, and a joyful lightness of movement, this variation captures the magical, ethereal quality of its otherworldly protagonist.',
      description: 'Danced through the magic of Petipa\'s Talisman, exploring the sparkling quick footwork, playful turns, and ethereal lightness that define this enchanting variation. A wonderful study in both precision and fairy-tale expressiveness.',
      dates: 'Feb 7th - Feb 28th, every Saturday',
      time: 'Noon - 2:00 PM',
      level: 'Beginner Friendly',
      image: talisman,
      completed: true
    },
    {
      month: 'December 2025',
      title: 'Dance of the Little Swans - Swan Lake',
      styleDescription: 'The Dance of the Little Swans is one of ballet\'s most iconic ensemble pieces, featuring four dancers moving in perfect synchronization. This beloved variation from Tchaikovsky\'s Swan Lake requires precise teamwork, coordination, and musical unity.',
      description: 'Explored one of ballet\'s most famous ensemble pieces! This special one-time workshop brought the joy of synchronized movement and teamwork, as dancers experienced the thrill of moving as one in this variation that has captivated audiences for over a century.',
      dates: 'December 13th, Saturday',
      time: '12:00 PM - 2:00 PM',
      level: 'Beginner Friendly',
      image: littleSwans,
      completed: true
    },
    {
      month: 'December 2025',
      title: 'Giselle Act 1 Variation',
      styleDescription: 'Giselle\'s Act 1 variation captures the essence of romantic ballet with its lyrical, expressive movements. This beloved variation showcases Giselle\'s innocent and joyful character through delicate footwork, graceful balances, and flowing upper body movement.',
      description: 'Explored the romantic ballet masterpiece in partnership with The Fifth Dance. This enchanting variation taught storytelling through movement, focusing on the delicate balance between technical precision and emotional expression.',
      dates: 'Nov 14th - Dec 5th, every Friday',
      time: '7:30 PM - 8:30 PM',
      level: 'Beginner Friendly',
      image: giselleAct1,
      completed: true
    },
    {
      month: 'November 2025',
      title: 'Lilac Fairy - Sleeping Beauty',
      styleDescription: 'The Lilac Fairy variation represents classical ballet at its most regal and sophisticated. This Petipa masterpiece features sweeping movements, elegant balances, and graceful traveling steps that embody wisdom and benevolence.',
      description: 'Explored the regal elegance of Petipa\'s masterpiece. This beautiful variation taught grace, musicality, and the art of storytelling through movement. Students learned the flowing port de bras, elegant balances, and traveling sequences that make this variation a true test of classical ballet artistry.',
      dates: 'Nov 1st - Nov 22nd, every Saturday',
      time: 'Noon - 2:00 PM',
      level: 'Beginner Friendly',
      image: lilacVariation,
      completed: true
    },
    {
      month: 'October 2025',
      title: 'Kitri Act 3 - Don Quixote',
      styleDescription: 'Kitri\'s Act 3 variation embodies the passionate Spanish style with bold, expressive movements. This challenging piece features sharp épaulement, dramatic port de bras, and intricate footwork including quick bourrées and turning sequences.',
      description: 'Mastered the fiery Spanish style and technical demands of one of ballet\'s most beloved variations. This iconic variation showcased the spirited character of Kitri with its dynamic choreography, featuring dramatic poses, quick directional changes, and expressive storytelling. ✨ Spanish fans included!',
      dates: 'Oct 4th - Oct 25th, every Saturday',
      time: 'Noon - 2:00 PM',
      level: 'Beginner Friendly',
      image: kitriAct3,
      completed: true
    },
    {
      month: 'September 2024',
      title: 'Emeralds - Jewel',
      styleDescription: 'Emeralds showcases Balanchine\'s signature neoclassical style with flowing, ethereal movements that emphasize musicality and pure dance.',
      description: 'Discovered the ethereal beauty of Balanchine\'s Emeralds with neoclassical style exploration.',
      dates: 'Sep 6th - Sep 27th, every Saturday',
      time: 'Noon - 2:00 PM',
      level: 'Beginner Friendly',
      image: emeralds,
      completed: true
    }
  ];

  return ReactDOM.createPortal(
    <div style={{
      position: 'fixed', inset: 0, backgroundColor: 'rgba(0, 0, 0, 0.8)', zIndex: 9999,
      display: 'flex', alignItems: isMobile ? 'flex-end' : 'center', justifyContent: 'center',
      padding: isMobile ? '0' : '20px',
      WebkitOverflowScrolling: 'touch'
    }}
      onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}
    >
      <div style={{
        backgroundColor: 'white',
        borderRadius: isMobile ? '16px 16px 0 0' : '15px',
        maxWidth: '900px', width: '100%',
        maxHeight: isMobile ? '95dvh' : '90vh',
        height: isMobile ? '95dvh' : 'auto',
        overflow: 'hidden',
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        paddingTop: isMobile ? 'env(safe-area-inset-top)' : 0,
        paddingBottom: isMobile ? 'env(safe-area-inset-bottom)' : 0
      }}>

        {/* Mobile Handle Bar */}
        {isMobile && (
          <div style={{ display: 'flex', justifyContent: 'center', padding: '8px 0 4px', flexShrink: 0 }}>
            <div style={{ width: '40px', height: '4px', background: '#ddd', borderRadius: '2px' }} />
          </div>
        )}

        {/* Sticky Close Button */}
        <button
          onClick={onClose}
          style={{
            position: 'absolute',
            top: isMobile ? 'calc(env(safe-area-inset-top) + 10px)' : '14px',
            right: isMobile ? '10px' : '14px',
            background: 'rgba(255, 255, 255, 0.95)',
            backdropFilter: 'blur(6px)',
            WebkitBackdropFilter: 'blur(6px)',
            border: '1px solid rgba(0,0,0,0.08)',
            boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
            fontSize: '22px', cursor: 'pointer',
            color: 'var(--charcoal)', zIndex: 20,
            width: '44px', height: '44px',
            borderRadius: '50%',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            lineHeight: 1, padding: 0,
            WebkitTapHighlightColor: 'transparent',
            transition: 'transform 0.15s ease'
          }}
          onTouchStart={(e) => { e.currentTarget.style.transform = 'scale(0.92)'; }}
          onTouchEnd={(e) => { e.currentTarget.style.transform = 'scale(1)'; }}
          aria-label="Close"
        >
          ×
        </button>

        {/* Share Button (sits to the left of Close) */}
        <button
          onClick={() => {
            const shareUrl = `${window.location.origin}/learn-explore?variations=open`;
            if (navigator.share) {
              navigator.share({
                title: 'PDC Explore Variations Series',
                text: 'Check out these ballet variation classes!',
                url: shareUrl
              });
            } else {
              navigator.clipboard.writeText(shareUrl);
              alert('Link copied to clipboard!');
            }
          }}
          style={{
            position: 'absolute',
            top: isMobile ? 'calc(env(safe-area-inset-top) + 10px)' : '14px',
            right: isMobile ? '64px' : '68px',
            background: 'rgba(255, 255, 255, 0.95)',
            backdropFilter: 'blur(6px)',
            WebkitBackdropFilter: 'blur(6px)',
            border: '1px solid rgba(0,0,0,0.08)',
            boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
            padding: 0,
            width: '44px', height: '44px',
            borderRadius: '50%',
            fontSize: '18px', fontWeight: '600',
            color: 'var(--primary-gold)',
            cursor: 'pointer',
            zIndex: 20,
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            WebkitTapHighlightColor: 'transparent',
            transition: 'transform 0.15s ease'
          }}
          onTouchStart={(e) => { e.currentTarget.style.transform = 'scale(0.92)'; }}
          onTouchEnd={(e) => { e.currentTarget.style.transform = 'scale(1)'; }}
          aria-label="Share"
        >
          ↗
        </button>

        {/* Scrollable Inner Content */}
        <div style={{
          overflowY: 'auto', overflowX: 'hidden', flex: 1,
          WebkitOverflowScrolling: 'touch',
          overscrollBehavior: 'contain'
        }}>

        {/* Header */}
        <div style={{
          padding: isMobile ? '1.5rem 1.25rem 1.25rem' : '40px 40px 20px',
          textAlign: 'center'
        }}>
          <h2 style={{
            fontSize: isMobile ? '1.8rem' : '2.5rem',
            color: 'var(--primary-gold)',
            marginBottom: '1rem',
            lineHeight: '1.2'
          }}>
            Explore Variations Series
          </h2>
          <p style={{
            fontSize: isMobile ? '1rem' : '1.2rem',
            color: 'var(--soft-gray)',
            lineHeight: '1.6',
            maxWidth: '700px',
            margin: '0 auto',
            padding: isMobile ? '0 10px' : '0 20px'
          }}>
            Join our 4-week variation series where students explore new and different styles of variations.
            Each month features a different piece, allowing dancers to broaden their repertoire and technique.
          </p>
        </div>

        {/* Navigation Tabs */}
        <div style={{
          padding: isMobile ? '0 20px' : '0 40px',
          borderBottom: '1px solid #eee',
          marginTop: '1.5rem'
        }}>
          <div style={{ display: 'flex', gap: '0' }}>
            {['upcoming', 'past'].map((tab) => (
              <button
                key={tab}
                onClick={() => setActiveTab(tab)}
                style={{
                  padding: isMobile ? '12px 20px' : '15px 25px',
                  border: 'none',
                  background: activeTab === tab ? 'var(--primary-gold)' : 'transparent',
                  color: activeTab === tab ? 'white' : 'var(--charcoal)',
                  fontWeight: activeTab === tab ? '600' : '400',
                  borderRadius: '10px 10px 0 0',
                  cursor: 'pointer',
                  textTransform: 'capitalize',
                  fontSize: isMobile ? '0.9rem' : '1rem'
                }}
              >
                {tab}
              </button>
            ))}
          </div>
        </div>

        {/* Content */}
        <div style={{
          padding: isMobile ? '20px 20px 30px' : '30px 40px 40px'
        }}>
          {activeTab === 'upcoming' && (
            <div>
              {/* All classes full */}
              <div style={{ textAlign: 'center', marginBottom: '2rem' }}>
                <h3 style={{ color: 'var(--primary-gold)', margin: '0 0 0.75rem 0', fontSize: isMobile ? '1.5rem' : '1.8rem', lineHeight: '1.3' }}>
                  All Classes Are Full
                </h3>
                <p style={{ color: 'var(--charcoal)', fontSize: isMobile ? '1rem' : '1.05rem', lineHeight: '1.7', maxWidth: '600px', margin: '0 auto' }}>
                  Thank you for your interest! All our current classes are full. We'll post new classes here soon.
                  In the meantime, check{' '}
                  <a href="https://www.thefifthdance.com/" target="_blank" rel="noopener noreferrer" style={{ color: 'var(--deep-gold)', fontWeight: 600 }}>
                    The Fifth Dance
                  </a>{' '}
                  for their classes. You can see our past classes in the tab above.
                </p>
              </div>

              {/* Newsletter Signup */}
              <div style={{ marginTop: '2rem', padding: isMobile ? '1.5rem' : '2rem', background: 'white', borderRadius: '12px', border: '2px solid var(--primary-gold)', textAlign: 'center' }}>
                <h3 style={{ color: 'var(--primary-gold)', marginBottom: '0.75rem', fontSize: '1.3rem' }}>Be the First to Know</h3>
                <p style={{ color: 'var(--charcoal)', marginBottom: '1.5rem', lineHeight: '1.6', maxWidth: '520px', margin: '0 auto 1.5rem', fontSize: isMobile ? '0.95rem' : '1rem' }}>
                  Enter your email and we'll tell you when new classes open.
                </p>

                {newsletterStatus === 'submitted' ? (
                  <div style={{ padding: '1rem', background: '#d4edda', color: '#155724', border: '1px solid #c3e6cb', borderRadius: '8px', maxWidth: '450px', margin: '0 auto 1rem' }}>
                    You're subscribed! Check your inbox for a welcome email. We'll notify you when new classes are announced.
                  </div>
                ) : (
                  <form onSubmit={handleNewsletterSubmit} style={{ display: 'flex', gap: '0.5rem', maxWidth: '450px', margin: '0 auto 1rem', flexDirection: isMobile ? 'column' : 'row' }}>
                    <input
                      type="email"
                      value={newsletterEmail}
                      onChange={(e) => setNewsletterEmail(e.target.value)}
                      placeholder="Your email address"
                      required
                      style={{ flex: 1, padding: '0.75rem 1rem', border: '1px solid #ddd', borderRadius: '6px', fontSize: isMobile ? '16px' : '1rem', boxSizing: 'border-box' }}
                    />
                    <button
                      type="submit"
                      disabled={newsletterSubmitting}
                      style={{ padding: '0.75rem 1.5rem', background: newsletterSubmitting ? '#ccc' : 'var(--primary-gold)', color: 'white', border: 'none', borderRadius: '6px', fontWeight: '600', fontSize: '1rem', cursor: newsletterSubmitting ? 'not-allowed' : 'pointer', whiteSpace: 'nowrap' }}
                    >
                      {newsletterSubmitting ? '...' : 'Sign Me Up'}
                    </button>
                  </form>
                )}

                {newsletterStatus === 'error' && (
                  <p style={{ color: '#dc3545', fontSize: '0.9rem', marginBottom: '0.5rem' }}>Something went wrong. Please try again.</p>
                )}

                <p style={{ color: 'var(--soft-gray)', fontSize: '0.85rem', marginTop: '1rem', lineHeight: '1.5' }}>
                  By signing up, you'll also join the <strong>Prix du Canada newsletter</strong> for competition updates, exclusive dancer resources, and early access to registration. You can unsubscribe at any time.
                </p>

                <p style={{ color: 'var(--soft-gray)', fontSize: '0.85rem', marginTop: '1rem' }}>
                  Questions?{' '}
                  <Link to="/contact" onClick={onClose} style={{ color: 'var(--primary-gold)', fontWeight: '600', textDecoration: 'none' }}>
                    Contact us here
                  </Link>.
                </p>
              </div>
            </div>
          )}

          {activeTab === 'past' && (
            <div>
              <h3 style={{ color: 'var(--primary-gold)', marginBottom: '2rem', fontSize: '1.5rem' }}>
                Past Classes
              </h3>
              <div style={{ display: 'grid', gap: '1.5rem' }}>
                {pastClasses.map((classItem, index) => (
                  <div key={index} style={{
                    border: '1px solid #eee',
                    borderRadius: '12px',
                    overflow: 'hidden',
                    background: '#fafafa'
                  }}>
                    {classItem.image ? (
                      <div style={{
                        display: isMobile ? 'block' : 'grid',
                        gridTemplateColumns: isMobile ? 'none' : '180px 1fr',
                        gap: isMobile ? '1rem' : '1.5rem',
                        padding: isMobile ? '1rem' : '1.5rem',
                        alignItems: 'start'
                      }}>
                        <img
                          src={classItem.image}
                          alt={classItem.title}
                          style={{
                            width: '100%',
                            height: isMobile ? '150px' : '120px',
                            objectFit: 'cover',
                            borderRadius: '8px',
                            marginBottom: isMobile ? '1rem' : '0'
                          }}
                        />
                        <div>
                          <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', marginBottom: '0.5rem' }}>
                            <h4 style={{ color: 'var(--charcoal)', fontSize: '1.1rem', margin: 0 }}>{classItem.title}</h4>
                            <span style={{ background: '#6c757d', color: 'white', padding: '4px 10px', borderRadius: '12px', fontSize: '0.75rem', fontWeight: '600' }}>Completed</span>
                          </div>
                          <p style={{ color: 'var(--soft-gray)', fontSize: '0.85rem', margin: '0.5rem 0' }}>
                            {classItem.dates} • {classItem.time} • {classItem.level}
                          </p>
                          <p style={{ margin: 0, lineHeight: '1.5', fontSize: '0.95rem', color: 'var(--charcoal)' }}>
                            {classItem.description}
                          </p>
                        </div>
                      </div>
                    ) : (
                      <div style={{ padding: isMobile ? '1rem' : '1.5rem' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', marginBottom: '0.5rem' }}>
                          <h4 style={{ color: 'var(--charcoal)', fontSize: '1.1rem', margin: 0 }}>{classItem.title}</h4>
                          <span style={{ background: '#6c757d', color: 'white', padding: '4px 10px', borderRadius: '12px', fontSize: '0.75rem', fontWeight: '600' }}>Completed</span>
                        </div>
                        <p style={{ color: 'var(--soft-gray)', fontSize: '0.85rem', margin: '0.5rem 0' }}>{classItem.month}</p>
                        <p style={{ margin: 0, lineHeight: '1.5', fontSize: '0.95rem', color: 'var(--charcoal)' }}>{classItem.description}</p>
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default ExploreVariationsClasses;
